/**
 * What an event of the staff stream makes stale on the map.
 *
 * The points themselves are not here: they move the markers in place
 * (`lib/positions.ts`). These are the events after which who is on the map,
 * or what is said of them, has changed: somebody came to work or left it, a
 * visit was given, set off to, done.
 */
import type { LiveEvent, Refresh } from "@/shared/live";

import { MAP_KEY } from "./queries";

/** Presence flickers, and a visit's move is told twice: wait for the rest. */
export const POSITIONS_DELAY_MS = 1_500;

const CHANGES_WHO_IS_AT_WORK: ReadonlySet<string> = new Set([
  "specialist.presence_changed",
  "specialist.status_changed",
  "visit.status_changed",
  "visit.assigned",
  "visit.released",
  "visit.cancelled",
  "visit.completed",
]);

export function mapLive(event: LiveEvent, refresh: Refresh): void {
  if (CHANGES_WHO_IS_AT_WORK.has(event.type)) {
    refresh([...MAP_KEY, "positions"], POSITIONS_DELAY_MS);
  }
}
